import axios from "../http_v2";

export default {
  web: {
    // 落地页
    info: data => {
      return axios.get(
        "/websitecenter/landingpage/netapi/build/template/findOne",
        data
      );
    },
    list: data => {
      return axios.post("/websitecenter/landingpage/build/findPage", data);
    },
    save: data => {
      return axios.post("/websitecenter/landingpage/build/save", data);
    }
  },
  template: {
    // 落地页页面模板
    list: data => {
      return axios.post(
        "/websitecenter/landingpage/landingpage/template/findPage",
        data
      );
    },
    save: data => {
      return axios.post(
        "/websitecenter/landingpage/landingpage/template/save",
        data
      );
    }
  },
  element: {
    // 落地页模块模板
    list: data => {
      return axios.post(
        "/websitecenter/landingpage/element/template/findPage",
        data
      );
    },
    save: data => {
      return axios.post(
        "/websitecenter/landingpage/element/template/save",
        data
      );
    }
  },
  type: {
    add: (params) => {
      return axios.post('websitecenter/landingpagesort/add', params)
    },
    update: (params) => {
      return axios.put('websitecenter/landingpagesort/update', params)
    },
    list: (params) => {
      return axios.get('websitecenter/landingpagesort/tree', params)
    },
    del: (params) => {
      return axios.delete('websitecenter/landingpagesort/del/' + params.id, params)
    }
  }
};
